import * as React from 'react';

import { Button } from '@independent-software/typeui/controls/Button';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { Label } from '@independent-software/typeui/controls/Label';
import { Latitude, Longitude } from '../../controls/GIS';
import { Number } from '@independent-software/typeui/formatters/Number';

import { Station } from '../../resource/'; 
import { Output } from '../../controls/Output';

interface IProps {
  station: Station;
  onClick: (item: Station) => void;
}

const MapStationsPopup = (props: IProps) => {
  return (
    <>
      <Header size="h3">Station {props.station.name}</Header>
      <div>{props.station.description}</div>
      <Label><Number value={props.station.samples_count} decimals={0}/> {props.station.samples_count == 1 ? 'sample' : 'samples'}</Label>
      <div style={{height:"4px"}}/>
      <Flex.Columns count={2}>
        <Output nobackground label="Latitude"><Label><Latitude value={props.station.latitude}/></Label></Output>
        <Output nobackground label="Longitude"><Label><Longitude value={props.station.longitude}/></Label></Output>
      </Flex.Columns>
      <div style={{textAlign: 'right', marginTop: '4px'}}>
        <Button onClick={() => props.onClick(props.station)}>View</Button>
      </div>
    </>      
  );
}

export { MapStationsPopup }
